import React from 'react';
import { Loader2, Radio } from 'lucide-react';
import { cn } from '@/lib/utils';
import { liveWords, liveLeftText } from '../../lib/chatLive';

/*
 * r16q7 (Live mode, docs/LIVE-MODE-DESIGN.md section 7): the tick. On, all automation on this chat's phone stops at once and the phone follows the chat open here. It comes back
 * when this is unticked or after the idle time. The line beside it says what's happening; there's no question to answer first.
 */
export default function LiveToggle({ live, slot, className }) {
  if (!live || !live.enabled || !slot) return null;
  const { session, running, ready, busy, error } = live;
  const words = error || liveWords(session);
  const waiting = running && !ready;
  const idleSoon = ready && session.idleLeftSec <= 60;
  return (
    <div className={cn('flex min-w-0 flex-wrap items-center gap-2', className)} data-testid="inbox-live" data-state={session ? session.state : 'off'}>
      <label className={cn('tap inline-flex h-8 cursor-pointer items-center gap-1.5 rounded-full border px-3 text-xs',
        ready ? 'border-success/50 bg-success/15 text-success' : 'border-white/10 bg-secondary/60 text-muted-foreground hover:text-foreground')} data-testid="inbox-live-tick">
        <input type="checkbox" className="h-3.5 w-3.5 accent-primary" checked={running} disabled={busy || (session && session.state === 'ENDING')}
          onChange={() => (running ? live.stop() : live.start())} aria-label="Live" />
        {waiting ? <Loader2 className="h-3.5 w-3.5 animate-spin" aria-hidden /> : <Radio className="h-3.5 w-3.5" aria-hidden />}Live
      </label>
      {!running && !words && <span className="text-xs text-muted-foreground" data-testid="inbox-live-hint">Stops all automation on this phone until you end it or it&apos;s idle for 10 minutes.</span>}
      {words && !ready && <span className={cn('text-xs', error ? 'text-danger' : 'text-muted-foreground')} role="status" data-testid="inbox-live-words">{words}</span>}
      {idleSoon && (
        <button type="button" onClick={() => live.activity(true)} data-testid="inbox-live-keep"
          className="tap inline-flex h-8 items-center rounded-full border border-warning/50 bg-warning/15 px-3 text-xs text-warning">
          Keep Live ({liveLeftText(session.idleLeftSec)})
        </button>
      )}
    </div>
  );
}
